import { render, staticRenderFns } from "./MapFeaturedComponent.vue?vue&type=template&id=761b6398&"
import script from "./MapFeaturedComponent.vue?vue&type=script&lang=js&"
export * from "./MapFeaturedComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/bramlinssen/Sites/ibonederland/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('761b6398')) {
      api.createRecord('761b6398', component.options)
    } else {
      api.reload('761b6398', component.options)
    }
    module.hot.accept("./MapFeaturedComponent.vue?vue&type=template&id=761b6398&", function () {
      api.rerender('761b6398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/MapFeaturedComponent.vue"
export default component.exports